var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61296 23.8002L8.12574 19.2994L8.01597 16.7746L3.84454 17.7626C3.5701 17.7443 3.10905 17.5979 3.46033 17.1588C4.52148 16.6465 6.99507 15.578 8.40018 15.4024L9.82725 15.3671L16.6882 13.7009L16.3588 13.3716C16.3039 13.1154 16.3369 12.6361 16.9077 12.7678L17.2663 12.8776L18.2799 9.25504L17.0724 7.88286C16.8162 7.64501 16.5235 7.21323 17.4017 7.38887L22.6709 7.33398C22.9636 7.33398 23.6259 7.49865 23.9333 8.15729H25.9641C26.2568 8.139 26.8094 8.42075 26.6776 9.69414C26.641 10.0235 26.4142 10.748 25.7994 11.0114L22.4513 12.2738L22.2867 14.4144V15.0731C22.2867 14.8535 22.3525 14.4693 22.8355 14.4693C22.9819 14.4876 23.3844 14.5901 23.3844 15.0731C23.3844 15.256 23.2417 15.622 22.8904 15.622C22.6892 15.6403 22.2867 15.5561 22.2867 15.0731V16.8844C22.2867 17.0307 22.4513 17.2796 23.11 17.1039L28.2145 15.7317C28.4523 15.7134 28.9829 15.7976 29.2024 16.2806C29.3122 16.6099 29.3781 17.3235 28.7633 17.543L22.2867 20.3971C21.9573 20.5984 21.1999 20.8582 20.8047 20.2874L19.8167 18.6956C19.6887 18.6408 19.4325 18.6188 19.4325 18.9701L20.0912 20.1776L11.3641 21.1107L5.76559 25.0626C5.58264 25.154 5.1289 25.2492 4.77762 24.8979C4.57994 24.7149 4.27025 24.2393 4.61296 23.8002Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3963,
    cy: 8.59555,
    r: 0.493985,
    fill: "#E20074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPets);
export default __webpack_public_path__ + "static/media/pets.938ef22c3a3d65ca1acec46d948883cc.svg";
export { ForwardRef as ReactComponent };